
import React from 'react';
import * as LucideIcons from 'lucide-react';

// Define type for icon names based on available Lucide icons
export type IconName = keyof typeof LucideIcons;

interface IconProps {
  name: IconName;
  className?: string;
  size?: number;
  color?: string;
  strokeWidth?: number;
}

export const Icon: React.FC<IconProps> = ({
  name,
  className,
  size = 24,
  color,
  strokeWidth = 2,
}) => {
  // TypeScript needs this cast to recognize it as a valid component
  const LucideIcon = LucideIcons[name] as React.ElementType;
  
  if (!LucideIcon) {
    console.error(`Icon "${name}" not found`);
    return null;
  }
  
  return <LucideIcon className={className} size={size} color={color} strokeWidth={strokeWidth} />;
};
